import { css, useTheme } from "@emotion/react";
import React from "react";
import { UpsunTheme } from "@upsun/react-component-library/src/themes";
import Heading from "@upsun/react-component-library/src/components/Heading";
import { checkmarks, mediaQueries, pxToRem } from "@upsun/react-component-library/src/styles";
import { fontSize } from "../../utils/pricing-page-styles";

type ProjectFeeProps = {
  pricingInfo: PricingInfoType
  currency: string
};

const ProjectFee: React.FC<ProjectFeeProps> = ({ pricingInfo, currency, ...props }) => {
  const theme = useTheme() as UpsunTheme;

  const checkmarksCustom = css`
    ${checkmarks};

    li::before {
      ${theme.name === "light"
        ? `
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='20' viewBox='0 0 24 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='tick'%3E%3Cpath id='Icon' d='M9.99999 15.1C9.69999 15.1 9.49999 15 9.29999 14.8L5.09999 10.6C4.69999 10.2 4.69999 9.60002 5.09999 9.20002C5.49999 8.80002 6.09999 8.80002 6.49999 9.20002L9.99999 12.7L17.5 5.20002C17.9 4.80002 18.5 4.80002 18.9 5.20002C19.3 5.60002 19.3 6.20002 18.9 6.60002L10.7 14.8C10.5 15 10.3 15.1 9.99999 15.1Z' fill='%234d38cc'/%3E%3C/g%3E%3C/svg%3E%0A");
      `
        : `
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='20' viewBox='0 0 24 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='tick'%3E%3Cpath id='Icon' d='M9.99999 15.1C9.69999 15.1 9.49999 15 9.29999 14.8L5.09999 10.6C4.69999 10.2 4.69999 9.60002 5.09999 9.20002C5.49999 8.80002 6.09999 8.80002 6.49999 9.20002L9.99999 12.7L17.5 5.20002C17.9 4.80002 18.5 4.80002 18.9 5.20002C19.3 5.60002 19.3 6.20002 18.9 6.60002L10.7 14.8C10.5 15 10.3 15.1 9.99999 15.1Z' fill='%23A090FF'/%3E%3C/g%3E%3C/svg%3E%0A");
      `}
    }
  `;

  const projectFee = css`
    margin-bottom: ${pxToRem(16)};

    ${mediaQueries.lg} {
      margin-bottom: 0;
    }
  `;

  return (
    <>
      <div>
        <Heading level={4} text={"Project fee"} />
        <div css={[projectFee, fontSize]}>
          {pricingInfo.projectFee[currency]}/project/month
        </div>
      </div>
      <div>
        <ul css={checkmarksCustom}>
          <li>On-demand preview environments</li>
          <li>30 days of infrastructure metrics</li>
          <li>15 minutes of continuous profiling</li>
          <li>2.5 hours of build CPU</li>
          <li>5 hours of build memory</li>
          <li>10 GB egress bandwidth</li>
          <li>500,000 ingress requests included</li>
        </ul>
      </div>
    </>
  );
};

export default ProjectFee;
